import React from 'react';
import './App.css';
// import ChatWindow from './components/ChatWindow';
import GameWindow from './components/GameWindow';

function App() {
  return (
    <div className="App">
      <GameWindow />
    </div>
  );
}

export default App;